module.exports = __webpack_public_path__ + "img/86.620b54e4.png";